import React from "react";
import ItemSelector from "components/ItemSelector";
import ItemView from "components/ItemView";
import ScoutQuestionnairesView from "components/ScoutQuestionnairesView";
import ProtectedRoute from "components/ProtectedRoute";
import { jwtDecode } from "jwt-decode";
import Programs from "views/auth/Programs";
import Academy from "views/auth/Academy";
import Schedule from "views/auth/Schedule";
import About from "views/auth/About";
import Contact from "views/auth/Contact";
import Directory from "views/auth/Directory";
import PlayerProfileDetail from "views/auth/PlayerProfileDetail";
import Register from "views/auth/Register";
import Join from "views/auth/Join";
import RegisterScout from './views/auth/RegisterScout';
import ScoutQuestionnaire from './views/auth/ScoutQuestionnaire';
import ScoutDecision from './views/auth/ScoutDecision';
import Fees from "views/auth/Fees";
import Success from "views/auth/Success";
import Reports from "components/Reports";
import UserReport from "components/UserReport";
import OfferLetter from "components/OfferLetter";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import RTLDefault from "views/rtl/default";
import AddWarehouse from "views/admin/warehouse/AddWarehouse";
import AddFairtradeRCN from "views/admin/warehouse/AddFairtradeRCN";
import AddOrganicRCN from "views/admin/warehouse/AddOrganicRCN";
import ViewWarehouse from "views/admin/warehouse/ViewWarehouse";
import ViewOrganic from "views/admin/warehouse/ViewOrganic";
import ViewFairTrade from "views/admin/warehouse/ViewFairTrade";
import Settings from "views/admin/settings/Settings";
import WarehouseDashboard from "views/admin/warehouse/WarehouseDashboard";
import ScanWarehouse from "views/admin/warehouse/ScanWarehouse";
import QRScanner from "views/admin/warehouse/QRScanner";
import UserList from "views/admin/users/UserList";
import AddUser from "views/admin/users/AddUser";
import EditUser from "views/admin/users/EditUser";

// Auth Imports
import SignIn from "views/auth/SignIn";
import Departments from "views/auth/Departments";


// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
  MdInventory,
  MdAdd,
  MdVisibility,
  MdQrCode2,
  MdSettings,
  MdQrCodeScanner,
  MdWarehouse,
  MdPeople
} from "react-icons/md";
import { FaFutbol, FaGraduationCap, FaCalendarAlt, FaUsers, FaEnvelope, FaUserPlus } from "react-icons/fa";
import { Payments } from "@mui/icons-material";
// import Departments from "views/auth/Departments";

const routes = [
  {
    name: "Departments",
    layout: "/auth",
    path: "departments",
    icon: <MdLock className="h-6 w-6" />,
    component: <Departments />,
    hidden: true,
  },
  // {
  //   name: "Main Dashboard",
  //   layout: "/admin",
  //   path: "default",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <MainDashboard />,
  // },
  {
    name: "KSA DASHBOARD",
    layout: "/admin",
    path: "warehouse",
    
    icon: <MdWarehouse className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <WarehouseDashboard />
      </ProtectedRoute>
    ),
    selectable: true,
    submenu: [
      {
        name: "Dashboard",
        layout: "/admin",
        path: "default",
        icon: <MdHome className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <WarehouseDashboard />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "View Reports",
        layout: "/admin",
        path: "reports",
        icon: <MdBarChart className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <Reports />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: () => {
          const storedData = localStorage.getItem('ksa_user');
          if (storedData) {
            try {
              const userData = JSON.parse(storedData);
              const token = userData.token;
              const decodedToken = jwtDecode(token);
              return decodedToken.role === 'user';
            } catch (error) {
              console.error('Error decoding token:', error);
              return false;
            }
          }
          return false;
        }
      },
      {
        name: "Add Reports",
        layout: "/admin",
        path: "user-reports",
        icon: <MdPeople className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <UserReport />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Sign In",
        layout: "/auth",
        path: "sign-in",
        icon: <MdLock className="h-6 w-6" />,
        hidden: true,
        component: <SignIn />,
      },
      {
        name: "Registered Players",
        layout: "/admin",
        path: "warehouse-add",
        icon: <MdAdd className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ItemSelector />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: () => {
          const storedData = localStorage.getItem('ksa_user');
          if (storedData) {
            try {
              const userData = JSON.parse(storedData);
              const token = userData.token;
              const decodedToken = jwtDecode(token);
              return decodedToken.role === 'user';
            } catch (error) {
              console.error('Error decoding token:', error);
              return false;
            }
          }
          return false;
        }
      },
      {
        name: "Add Warehouse",
        layout: "/admin",
        path: "warehouse-add/new",
        component: <AddWarehouse />,
        hidden: true,
        selectable: false,
      },
      {
        name: "Add Fair Trade RCN",
        layout: "/admin",
        path: "warehouse-add/fairtrade",
        component: <AddFairtradeRCN />,
        hidden: true,
        selectable: false,
      },
      {
        name: "Add Organic RCN",
        layout: "/admin",
        path: "warehouse-add/organic",
        component: <AddOrganicRCN />,
        hidden: true,
        selectable: false,
      },


      {
        name: "Registered Scouts",
        layout: "/admin",
        path: "warehouse-view",
        icon: <MdVisibility className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ItemView />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: () => {
          const storedData = localStorage.getItem('ksa_user');
          if (storedData) {
            try {
              const userData = JSON.parse(storedData);
              const token = userData.token;
              const decodedToken = jwtDecode(token);
              return decodedToken.role === 'user';
            } catch (error) {
              console.error('Error decoding token:', error);
              return false;
            }
          }
          return false;
        }
      },
      {
        name: "Contact",
        layout: "/auth",
        path: "contact",
        icon: <FaEnvelope className="h-5 w-5" />,
        component: <Contact />,
        selectable: true,
      },
      {
        name: "Scout Questionnaires",
        layout: "/admin",
        path: "warehouse-view/questionnaires",
        component: (
          <ProtectedRoute>
            <ScoutQuestionnairesView />
          </ProtectedRoute>
        ),
        selectable: false,
        hidden: true,
      },
      {
        name: "View Calibrated RCN",
        layout: "/admin",
        path: "warehouse/view",
        icon: <MdVisibility className="h-5 w-5" />,
        component: <ViewWarehouse />,
        selectable: true,
        hidden: true,

      },
      {   
        name: "View Organic RCN",
        layout: "/admin",
        path: "warehouse/view/organic",   
        icon: <MdVisibility className="h-5 w-5" />,
        component: <ViewOrganic />,
        selectable: true,
        hidden: true,
      },
      {
        name: "View Fair Trade RCN",
        layout: "/admin",
        path: "warehouse/view/fairtrade",
        icon: <MdVisibility className="h-5 w-5" />,
        component: <ViewFairTrade />, 
        selectable: true,
        hidden: true,
      },
      
      // {
      //   name: "Scan QR",
      //   layout: "/admin",
      //   path: "warehouse-scan",
      //   icon: <MdQrCodeScanner className="h-5 w-5" />,
      //   component: <QRScanner />,
      //   selectable: true,
      // },
      // {
      //   name: "Scan Result",
      //   layout: "/admin",
      //   path: "warehouse-view/:id",
      //   component: <ScanWarehouse />,
      //   hidden: true,
      //   selectable: false
      // },
      // {
      //   name: "Generate QR",
      //   layout: "/admin",
      //   path: "warehouse-qr",
      //   icon: <MdQrCode2 className="h-5 w-5" />,
      //   component: <MainDashboard />,
      // }
    ]
  },
  // {
  //   name: "Users",
  //   layout: "/admin",
  //   path: "users",
  //   icon: <MdPeople className="h-6 w-6" />,
  //   component: (
  //     <ProtectedRoute>
  //       <UserList />
  //     </ProtectedRoute>
  //   ),
  //   selectable: true,
  //   hidden: () => {
  //     const token = localStorage.getItem('usibras_login');
  //     if (token) {
  //       try {
  //         const decodedToken = jwtDecode(token);
  //         return decodedToken.role === 'user';
  //       } catch (error) {
  //         console.error('Error decoding token:', error);
  //         return false;
  //       }
  //     }
  //     return false;
  //   },
  //   submenu: [
  //     {
  //       name: "View Users",
  //       layout: "/admin",
  //       path: "users-view",
  //       icon: <MdVisibility className="h-5 w-5" />,
  //       component: (
  //         <ProtectedRoute>
  //           <UserList />
  //         </ProtectedRoute>
  //       ),
  //       selectable: true,
  //     },
  //     {
  //       name: "Add User",
  //       layout: "/admin",
  //       path: "users-add",
  //       icon: <MdAdd className="h-5 w-5" />,
  //       component: (
  //         <ProtectedRoute>
  //           <AddUser />
  //         </ProtectedRoute>
  //       ),
  //       selectable: true,
  //     },
  //     {
  //       name: "Edit User",
  //       layout: "/admin",
  //       path: "users-edit/:id",
  //       component: (
  //         <ProtectedRoute>
  //           <EditUser />
  //         </ProtectedRoute>
  //       ),
  //       hidden: true,
  //       selectable: false,
  //     }
  //   ]
  // },
  
  


  // {
  //   name: "NFT Marketplace",
  //   layout: "/admin",
  //   path: "nft-marketplace",
  //   icon: <MdOutlineShoppingCart className="h-6 w-6" />,
  //   component: <NFTMarketplace />,
  // },
  // {
  //   name: "Data Tables",
  //   layout: "/admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   path: "data-tables",
  //   component: <DataTables />,
  // },
  // {
  //   name: "Profile",
  //   layout: "/admin",
  //   path: "profile",
  //   icon: <MdPerson className="h-6 w-6" />,
  //   component: <Profile />,
  // },
  // {
  //   name: "Settings",
  //   layout: "/admin",
  //   path: "settings",
  //   icon: <MdSettings className="h-6 w-6" />,
  //   component: (
  //     <ProtectedRoute>
  //       <Settings />
  //     </ProtectedRoute>
  //   ),
  //   selectable: true,
  // },
  
  // {
  //   name: "RTL Admin",
  //   layout: "/rtl",
  //   path: "rtl",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <RTLDefault />,
  // },
  {
    path: "/warehouse/view",
    element: <ViewWarehouse />,
  },
  {
    name: "Programs",
    layout: "/auth",
    path: "programs",
    icon: <FaFutbol className="h-6 w-6" />,
    component: <Programs />,
    hidden: true,
  },
  {
    name: "Directory",
    layout: "/auth",
    path: "directory",
    icon: <FaUsers className="h-6 w-6" />,
    component: <Directory />,
    hidden: true,
  },
  {
    name: "Player Profile",
    layout: "/auth",
    path: "directory/:id",
    icon: <FaUsers className="h-6 w-6" />,
    component: <PlayerProfileDetail />,
    hidden: true,
  },
  {
    name: "Offer Letter Demo",
    layout: "/auth",
    path: "offer-letter-demo",
    icon: <FaFutbol className="h-6 w-6" />,
    component: <OfferLetter scoutName="John Doe" startDate="1 May 2026" yourName="Director Name" />,
    hidden: true,
  },
  {
    name: "Academy",
    layout: "/auth",
    path: "academy",
    icon: <FaGraduationCap className="h-6 w-6" />,
    component: <Academy />,
    hidden: true,
  },
  {
    name: "Schedule",
    layout: "/auth",
    path: "schedule",
    icon: <FaCalendarAlt className="h-6 w-6" />,
    component: <Schedule />,
    hidden: true,
  },
  {
    name: "Fees",
    layout: "/auth",
    path: "fees",
    icon: <Payments className="h-6 w-6" />,
    component: <Fees />,
    hidden: true,
  },
  {
    name: "About",
    layout: "/auth",
    path: "about",
    icon: <FaUsers className="h-6 w-6" />,
    component: <About />,
    hidden: true,
  },
  {
    name: "Contact",
    layout: "/auth",
    path: "contact",
    icon: <FaEnvelope className="h-6 w-6" />,
    component: <Contact />,
    hidden: true,
  },
  {
    name: "Register",
    layout: "/auth",
    path: "register",
    icon: <FaUserPlus className="h-6 w-6" />,
    component: <Register />,
    hidden: true,
  },
  {
    name: "Register Scout",
    layout: "/auth",
    path: "register-scout",
    icon: <FaUserPlus className="h-6 w-6" />,
    component: <RegisterScout />,
    hidden: true,
  },
  {
    name: "Scout Questionnaire",
    layout: "/auth",
    path: "scout-questionnaire/:id",
    icon: <FaUserPlus className="h-6 w-6" />,
    component: <ScoutQuestionnaire />,
    hidden: true,
  },
  {
    name: "Scout Decision",
    layout: "/auth",
    path: "scout-decision/:id",
    icon: <FaUserPlus className="h-6 w-6" />,
    component: <ScoutDecision />,
    hidden: true,
  },
  {
    name: "Join",
    layout: "/auth",
    path: "join",
    icon: <FaUserPlus className="h-6 w-6" />,
    component: <Join />,
    hidden: true,
  },
  {
    name: "Success",
    layout: "/auth",
    path: "success",
    icon: <FaUserPlus className="h-6 w-6" />,
    component: <Success />,
    hidden: true,
  },
];
export default routes;
